import * as React from 'react';
import * as ApiTypes from '../../../models/ApiTypes';
import { Glyphicon } from 'react-bootstrap';

interface IAuftragAdesseProps {
  auftrag: ApiTypes.IAuftrag;
  adressArt: ApiTypes.AdressArt;
}

/** Komponente zur Anzeige einer im Auftrag hinterlegten Adresse */
export default class AuftragAdesse extends React.Component<IAuftragAdesseProps, {}> {

  private renderAdresseAuftraggeber() {
    let { auftrag } = this.props;
    const ort = `${this.props.auftrag.auftraggeber_plz || ''} ${this.props.auftrag.auftraggeber_ort || ''}`;
    // Anzeige der Untersuchungsstelle als Meta-Datum für alte SES-Aufträge vor Umstellung auf explizite Adressen
    // @todo: kann nach Übergangsphase weg
    let ust: string | undefined;
    if (auftrag.kategorie === ApiTypes.AUFTRAG_KATEGORIE_SES) {
      if (auftrag.meta) {
        let metadatum = auftrag.meta.find((meta) => meta.bezeichnung === ApiTypes.SES_UST);
        if (metadatum) {
          const inhalt = metadatum.inhalt.trim();
          if ((inhalt.length > 0) && (inhalt !== '(ohne)')) {
            ust = metadatum.inhalt;
          }
        }
      }
    }

    return (
      <div className="auftraggeber">
        <div className="auftraggeber-links">
          {(auftrag.auftraggeber_name1) && (
            <div>{auftrag.auftraggeber_name1}</div>
          )}
          {(auftrag.auftraggeber_name2) && (
            <div>{auftrag.auftraggeber_name2}</div>
          )}
          {(auftrag.auftraggeber_strasse) && (
            <div>{auftrag.auftraggeber_strasse}</div>
          )}
          {(ort.trim().length > 0) && (
            <div>{ort}</div>
          )}
          {(auftrag.auftraggeber_tel) && (auftrag.auftraggeber_tel.trim().length > 0) && (
            <div><Glyphicon glyph="earphone" /> {auftrag.auftraggeber_tel}</div>
          )}
          {(auftrag.auftraggeber_email) && (auftrag.auftraggeber_email.trim().length > 0) && (
            <div><Glyphicon glyph="envelope" /> {auftrag.auftraggeber_email}</div>
          )}
        </div>
        {/* @todo: kann nach Übergangsphase weg         */}
        <div className="auftraggeber-rechts">
          {(ust) && (
            <div><Glyphicon glyph="map-marker" /> {ust}</div>
          )}
        </div>
      </div>
    );
  }

  /** Die Adresse des Beauftragten wird im Laborumfeld für den Ort der Untersuchung verwendet */
  private renderAdresseBeauftragter() {
    let { auftrag } = this.props;
    const ort = `${auftrag.beauftragter_plz || ''} ${auftrag.beauftragter_ort || ''}`;
    return (
      <div className="auftraggeber">
        <div className="auftraggeber-links">
          {(auftrag.beauftragter_name1) && (
            <div>{auftrag.beauftragter_name1}</div>
          )}
          {(auftrag.beauftragter_name2) && (
            <div>{auftrag.beauftragter_name2}</div>
          )}
          {(auftrag.beauftragter_strasse) && (
            <div>{auftrag.beauftragter_strasse}</div>
          )}
          {(ort.trim().length > 0) && (
            <div>{ort}</div>
          )}
          {(auftrag.beauftragter_tel) && (auftrag.beauftragter_tel.trim().length > 0) && (
            <div><Glyphicon glyph="earphone" /> {auftrag.beauftragter_tel}</div>
          )}
          {(auftrag.beauftragter_email) && (auftrag.beauftragter_email.trim().length > 0) && (
            <div><Glyphicon glyph="envelope" /> {auftrag.beauftragter_email}</div>
          )}
        </div>
        {auftrag.untersuchungsstellenkennung &&
          <div className="auftraggeber-rechts">
              <div><Glyphicon glyph="map-marker" /> {auftrag.untersuchungsstellenkennung}</div>
          </div>}
      </div>
    );
  }

  render() {
    switch (this.props.adressArt) {
      case ApiTypes.AdressArt.Auftraggeber:
        return this.renderAdresseAuftraggeber();
      case ApiTypes.AdressArt.Beauftragter:
        return this.renderAdresseBeauftragter();
      default:
        return <div/>;
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/adressen/AuftragAdesse.tsx